var Alberta = "Альберта";
var Manitoba = "Манитоба";
var Nunavut = "Нунавут";
var Ontario = "Онтарио";
var Quebec = "Квебек";
var Saskatchewan = "Саскачеван";
var Yukon = "Юкон";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "Британская Колумбия",
	Manitoba: Manitoba,
	"New Brunswick": "Нью-Брансуик",
	"Newfoundland and Labrador": "Ньюфаундленд и Лабрадор",
	"Northwest Territories": "Северо-Западные территории",
	"Nova Scotia": "Новая Шотландия",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "Остров Принца Эдуарда",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
